<template>
    <v-container class="mb-6">

        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>

        <v-card class="elevation-2 mt-5 mb-8">
            <v-card-title class="flex-nowrap">
                {{ $t('Filtros') }}
            </v-card-title>
            <v-card-text>
                <form @submit.prevent="processSearch">
                    <v-row align="center">
                        <v-col cols="12" sm="6">
                            <v-menu
                                ref="menuInit"
                                v-model="menuInit"
                                :close-on-content-click="false"
                                :return-value.sync="dateInit"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="dateInit"
                                    label="Fecha inicial"
                                    prepend-inner-icon="mdi-calendar"
                                    outlined
                                    dense
                                    hide-details
                                    v-bind="attrs"
                                    v-on="on"
                                ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="dateInit"
                                    no-title
                                    scrollable
                                    locale="es"
                                    color="primary"
                                    class="ma-0"
                                >
                                    <v-spacer></v-spacer>
                                    <v-btn
                                        text
                                        color="red"
                                        @click="menuInit = false"
                                    >
                                        {{ $t('Cancelar') }}
                                    </v-btn>
                                    <v-btn
                                        color="primary"
                                        @click="$refs.menuInit.save(dateInit)"
                                    >
                                        {{ $t('Aceptar') }}
                                    </v-btn>
                                </v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-menu
                                ref="menuEnd"
                                v-model="menuEnd"
                                :close-on-content-click="false"
                                :return-value.sync="dateEnd"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="dateEnd"
                                    :label="$t('Fecha final')"
                                    prepend-inner-icon="mdi-calendar"
                                    outlined
                                    dense
                                    hide-details
                                    v-bind="attrs"
                                    v-on="on"
                                ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="dateEnd"
                                    no-title
                                    scrollable
                                    locale="es"
                                    color="primary"
                                    class="ma-0"
                                >
                                    <v-spacer></v-spacer>
                                    <v-btn
                                        text
                                        color="red"
                                        @click="menuEnd = false"
                                    >
                                        {{ $t('Cancelar') }}
                                    </v-btn>
                                    <v-btn
                                        color="primary"
                                        @click="$refs.menuEnd.save(dateEnd)"
                                    >
                                        {{ $t('Aceptar') }}
                                    </v-btn>
                                </v-date-picker>
                            </v-menu>
                        </v-col>
                    </v-row>
                    <div class="text-right mt-8">
                        <!-- <v-btn
                            class="text-capitalize mb-2 mb-sm-0 mr-2"
                            :href="`/admin/export-inventory?date_init=${dateInit}&date_end=${dateEnd}&type=${seeIn}`"
                        >
                            <v-icon class="mr-2" color="green">mdi-file-excel</v-icon>
                            {{ $t('Exportar') }}
                        </v-btn> -->

                        <v-btn
                            color="primary"
                            type="submit"
                        >
                            {{ $t('Buscar') }}
                        </v-btn>
                        <v-btn
                            color="red"
                            text
                            v-show="(dateInit!='') || (dateEnd!='')"
                            @click="cleanSearch('')"
                        >
                            {{ $t('Limpiar') }}
                        </v-btn>
                    </div>
                </form>
            </v-card-text>
        </v-card>

        <!-- card main -->
        <v-card class="elevation-2 mt-5">
            <v-card-title class="blue-grey darken-4 white--text">
                <div class="" style="justify-content: space-between;display: flex;width: 100%;">
                    <div>
                        {{$t('Historial de cajas')}}
                    </div>
                    <div>
                        <v-btn
                            class="text-capitalize mb-2 mb-sm-0 mr-2"
                            :href="`/admin/history-cashier-export?orderby=${this.orderBy}&ordertype=${this.orderType}&cash=${this.txtCash}&user=${this.txtUser}&type=${this.txtType}&fecha=${this.txtFecha}&date_init=${this.dateInit}&date_end=${this.dateEnd}`"
                        >
                            <v-icon class="mr-2" color="green">mdi-file-excel</v-icon>
                            {{ $t('Exportar') }}
                        </v-btn>
                    </div>
                </div>
            </v-card-title>

            <v-simple-table>
                <template v-slot:default>
                <thead>
                    <tr>
                        <th class="text-left">
                            <div class="d-flex align-center">
                                <span>{{$t('Nombre usuario')}}</span>
                                <div class="wrap-order">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-up"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='DESC', orderBy='full_name', getListHistoryCashier()"
                                            ></span>
                                        </template>
                                        <span>{{$t('Orden descendente')}}</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-down"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='ASC', orderBy='full_name', getListHistoryCashier()"
                                            ></span>
                                        </template>
                                        <span>{{$t('Orden ascendente')}}</span>
                                    </v-tooltip>
                                </div>
                                <v-menu offset-y :close-on-content-click="false">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                        color="primary"
                                        dark
                                        icon
                                        small
                                        v-bind="attrs"
                                        v-on="on"
                                        >
                                            <v-icon>mdi-filter</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-text>
                                            <form @submit.prevent="processSearch">
                                                <v-text-field
                                                    v-model="txtUser"
                                                    :label="$t('Nombre')"
                                                    outlined
                                                    dense
                                                    hide-details
                                                    type="text"
                                                ></v-text-field>
                                                <div class="text-right mt-4">
                                                    <v-btn
                                                        color="primary"
                                                        type="submit"
                                                        flat
                                                        small
                                                    >
                                                        <v-icon>mdi-magnify</v-icon>
                                                    </v-btn>
                                                    <v-btn
                                                        color="red"
                                                        text
                                                        small
                                                        @click="cleanSearch('user')"
                                                    >
                                                        {{$t('Limpiar')}}
                                                    </v-btn>
                                                </div>
                                            </form>
                                        </v-card-text>
                                    </v-card>
                                </v-menu>
                            </div>
                        </th>
                        <th class="text-left" style="min-width:150px">
                            <div class="d-flex align-center">
                                <span>{{$t('Fecha y hora')}}</span>
                                <div class="wrap-order">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-up"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='DESC', orderBy='created_at', getListHistoryCashier()"
                                            ></span>
                                        </template>
                                        <span>{{$t('Orden descendente')}}</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-down"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='ASC', orderBy='created_at', getListHistoryCashier()"
                                            ></span>
                                        </template>
                                        <span>{{$t('Orden ascendente')}}</span>
                                    </v-tooltip>
                                </div>
                                <v-menu offset-y :close-on-content-click="false">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                        color="primary"
                                        dark
                                        icon
                                        small
                                        v-bind="attrs"
                                        v-on="on"
                                        >
                                            <v-icon>mdi-filter</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-text>
                                            <form @submit.prevent="processSearch">
                                                <v-text-field
                                                    v-model="txtFecha"
                                                    :label="$t('Fecha')"
                                                    outlined
                                                    dense
                                                    hide-details
                                                    type="date"
                                                ></v-text-field>
                                                <div class="text-right mt-4">
                                                    <v-btn
                                                        color="primary"
                                                        type="submit"
                                                        flat
                                                        small
                                                    >
                                                        <v-icon>mdi-magnify</v-icon>
                                                    </v-btn>
                                                    <v-btn
                                                        color="red"
                                                        text
                                                        small
                                                        @click="cleanSearch('fecha')"
                                                    >
                                                        {{$t('Limpiar')}}
                                                    </v-btn>
                                                </div>
                                            </form>
                                        </v-card-text>
                                    </v-card>
                                </v-menu>
                            </div>
                        </th>
                        <th class="text-left">
                            <div class="d-flex align-center">
                                <span>{{$t('tipo')}}</span>
                                <div class="wrap-order">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-up"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='DESC', orderBy='type', getListHistoryCashier()"
                                            ></span>
                                        </template>
                                        <span>{{$t('Orden descendente')}}</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-down"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='ASC', orderBy='type', getListHistoryCashier()"
                                            ></span>
                                        </template>
                                        <span>{{$t('Orden ascendente')}}</span>
                                    </v-tooltip>
                                </div>
                                <v-menu offset-y :close-on-content-click="false">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                        color="primary"
                                        dark
                                        icon
                                        small
                                        v-bind="attrs"
                                        v-on="on"
                                        >
                                            <v-icon>mdi-filter</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-text>
                                            <form @submit.prevent="processSearch">
                                                <v-text-field
                                                    v-model="txtType"
                                                    label="tipo"
                                                    outlined
                                                    dense
                                                    hide-details
                                                    type="text"
                                                ></v-text-field>
                                                <div class="text-right mt-4">
                                                    <v-btn
                                                        color="primary"
                                                        type="submit"
                                                        flat
                                                        small
                                                    >
                                                        <v-icon>mdi-magnify</v-icon>
                                                    </v-btn>
                                                    <v-btn
                                                        color="red"
                                                        text
                                                        small
                                                        @click="cleanSearch('type')"
                                                    >
                                                        {{$t('Limpiar')}}
                                                    </v-btn>
                                                </div>
                                            </form>
                                        </v-card-text>
                                    </v-card>
                                </v-menu>
                            </div>
                        </th>
                        <th class="text-left">
                            <div class="d-flex align-center">
                                <span>{{$t('Efectivo declarado')}}</span>
                                <div class="wrap-order">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-up"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='DESC', orderBy='cash_by_user', getListHistoryCashier()"
                                            ></span>
                                        </template>
                                        <span>{{$t('Orden descendente')}}</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-down"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='ASC', orderBy='cash_by_user', getListHistoryCashier()"
                                            ></span>
                                        </template>
                                        <span>{{$t('Orden ascendente')}}</span>
                                    </v-tooltip>
                                </div>
                                <v-menu offset-y :close-on-content-click="false">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                        color="primary"
                                        dark
                                        icon
                                        small
                                        v-bind="attrs"
                                        v-on="on"
                                        >
                                            <v-icon>mdi-filter</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-text>
                                            <form @submit.prevent="processSearch">
                                                <v-text-field
                                                    v-model="txtCash"
                                                    :label="$t('Efectivo declarado')"
                                                    outlined
                                                    dense
                                                    hide-details
                                                    type="text"
                                                ></v-text-field>
                                                <div class="text-right mt-4">
                                                    <v-btn
                                                        color="primary"
                                                        type="submit"
                                                        flat
                                                        small
                                                    >
                                                        <v-icon>mdi-magnify</v-icon>
                                                    </v-btn>
                                                    <v-btn
                                                        color="red"
                                                        text
                                                        small
                                                        @click="cleanSearch('cash')"
                                                    >
                                                        {{$t('Limpiar')}}
                                                    </v-btn>
                                                </div>
                                            </form>
                                        </v-card-text>
                                    </v-card>
                                </v-menu>
                            </div>
                        </th>
                        <th class="text-left">
                            <div class="d-flex align-center">
                                <span>Final {{$t('caja')}}</span>
                            </div>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in listHistoryCashier" :key="index">
                        <td>{{ item.full_name }}</td>
                        <td>{{ item.date }}</td>
                        <td>{{ item.type=='open' ? 'Apertura' : 'Cierre' }}</td>
                        <td>{{ item.cash_by_user }}</td>
                        <td>{{ item.final_cash }}</td>
                    </tr>
                </tbody>
                </template>
            </v-simple-table>
        </v-card>
        <div class="text-right py-2" v-html="pageTable"></div>
        <v-pagination
            v-model="page"
            :length="totalPage"
            :total-visible="5"
            color="primary"
            @input="changePage"
            class="my-5"
        ></v-pagination>
        <!-- end card main -->

        <!-- overlay -->
        <v-overlay :value="overlay" opacity=".9" z-index="10">
            <v-progress-circular
                indeterminate
                size="64"
                color="primary"
            ></v-progress-circular>
        </v-overlay>
        <!-- end overlay -->

    </v-container>
</template>
<script>
import dayjs from 'dayjs';

export default {
    data() {
        return {
            overlay: false,
            loading: false,
            loading2: false,
            breadcrumbs: [
                // {
                //     text: 'Pedidos',
                //     disabled: false,
                //     href: '/admin/orders',
                // },
                {
                    text: 'Historial de cajas',
                    disabled: true,
                    href: '',
                }
            ],
            tmpSlug: 'http://'+window.location.hostname+'/',
            // list data
            listHistoryCashier: [],
            pageTable: '',
            page: 1,
            totalPage: null,
            txtUser: '',
            txtFecha: '',
            txtCash: '',
            txtType: '',
            // export
            menuInit: false,
            menuEnd: false,
            dateInit: '',
            dateEnd: '',
            orderType: 'DESC',
            orderBy: 'created_at',
            // actualizar estados
            itemsStates: ['Nuevo', 'Pendiente', 'Completado', 'Reembolsado', 'Fallido'],
            state: '',
        }
    },
    props: ['money'],
    mounted() {
        this.getListHistoryCashier()
    },
    methods: {
        /**
         * List categories
         */
        processSearch () {
            this.page = 1
            this.getListHistoryCashier()
        },
        changePage (event) {
            this.page = event;
            this.getListHistoryCashier()
        },
        cleanSearch (type='') {
            if (type=='') {
                if ( (this.txtCash!=='') || (this.txtUser!=='') || (this.txtType!='') || (this.txtFecha!='') || (this.dateInit!='') || (this.dateEnd!='') ) {
                    this.listHistoryCashier = []
                    this.page = 1
                    this.txtCash = ''
                    this.txtUser = ''
                    this.txtType = ''
                    this.txtFecha = ''
                    this.dateInit = ''
                    this.dateEnd = ''
                    this.getListHistoryCashier();
                }
            } else {
                switch (type) {
                    case 'cash':
                        this.txtCash = ''
                        this.getListHistoryCashier();
                        break;
                    case 'user':
                        this.txtUser = ''
                        this.getListHistoryCashier();
                        break;
                    case 'type':
                        this.txtType = ''
                        this.getListHistoryCashier();
                        break;
                    case 'fecha':
                        this.txtFecha = ''
                        this.getListHistoryCashier();
                        break;
                    default:
                        break;
                }
            }
        },
        async getListHistoryCashier () {
            this.listHistoryCashier = []
            this.overlay = true
            await axios.post(`/admin/list-history-cashier?page=${this.page}
                            &orderby=${this.orderBy}
                            &ordertype=${this.orderType}
                            &cash=${this.txtCash}
                            &user=${this.txtUser}
                            &type=${this.txtType}
                            &fecha=${this.txtFecha}
                            &date_init=${this.dateInit}
                            &date_end=${this.dateEnd}
                        `, {})
            .then(response => {
                // console.log(response)
                response.data.data.forEach(element => {
                    // const d = new Date(element.created_at)
                    // element.date = d.getDate() +'-'+ (d.getMonth()+1) +'-'+ d.getFullYear() +'  '+ d.getHours()+':'+d.getMinutes()
                    element.date = this.formatDate(element.created_at);
                    this.listHistoryCashier.push(element)
                });
                // this.listHistoryCashier = response.data[0].data
                this.totalPage = response.data.last_page
                this.pageTable = `Mostrando <strong>${response.data.from??0} - ${response.data.to??0}</strong> de un total de <strong>${response.data.total}</strong>`

                this.overlay = false
            })
            .catch(error => {
                console.log(error)
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                }
                this.overlay = false
            })
        },

        /**
         * Aceptar/rechazar
         */
        async aceptarRechazar(type, id) {
            this.loading2 = true
            await axios.post('/admin/accept-reject', {type:type, id:id})
            .then((response) => {
                // console.log(response)
                if (response.data == 'ok') {
                    this.$alert('', 'Cambio de estado con éxito.', 'success', {confirmButtonText: 'Continuar'})
                    this.getListHistoryCashier()
                }
                this.loading2 = false
            })
            .catch((error) => {
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                }
                this.loading2 = false
            })
        },
        formatDate(date) {
            if(!date) { return ''; }
            const formatted = dayjs(date).format('DD/MM/YYYY HH:mm');
            return formatted;
        }
    },
}
</script>
